// Function to remove all og:url meta tags
function removeAllOgUrlMetaTags() {
  const ogUrlMetaTags = document.querySelectorAll('meta[property="og:url"]');
  ogUrlMetaTags.forEach(tag => tag.remove()); // Loop through and remove each tag
}

// Call the function to remove all og:url meta tags
removeAllOgUrlMetaTags();
